import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import BasicDetailsCard from '../../../../components/common/BasicDetailsCard';
import { VendorAprovedGetsingle, VendorRequestPUTsingle } from '../../../../services/api/vendor';
import MenuTable from '../../../../components/common/Vendor/Permmission';
import BussinessDetailsCard from '../../../../components/common/Vendor/BusinessDetailsCard';
import FixedBackButton from '../Vendor-ui/BackButton';

export default function VendorApprovedView() {
	const { id } = useParams();
	const [vendorData, setVendorData] = useState<any>(null);
	const [loading, setLoading] = useState(true);

	const [vendorDisabel, setvendorDisabel] = useState(false);
	// Fetch vendor data
	const fetchData = async () => {
		try {
			const response = await VendorAprovedGetsingle(id);
			if (response?.success) {
				setVendorData(response.data.vendor);
			}
		} catch (error) {
			console.error('Error fetching vendor details:', error);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchData();
		setvendorDisabel(true);
	}, []);

	// Handle permission change in real time
	const handlePermissionChange = async (updatedPermissions: any) => {
		if (!vendorData) return;
		setVendorData((prev: any) => ({ ...prev, permissions: updatedPermissions }));

		const payload = {
			businessName: vendorData.businessName,
			businessType: vendorData.businessType,
			firstName: vendorData.firstName,
			lastName: vendorData.lastName,
			email: vendorData.email,
			mobile: vendorData.mobile,
			companyAddress: vendorData.companyAddress,
			permissions: updatedPermissions,
			gstNumber: vendorData.gstNumber,
			// status: vendorData.status || 'pending',
		};

		try {
			await VendorRequestPUTsingle(id, payload);
		} catch (error) {
			console.error('Error updating permissions:', error);
		}
	};

	if (loading) {
		return (
			<Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
				<CircularProgress />
			</Box>
		);
	}

	if (!vendorData) {
		return <Box sx={{ textAlign: 'center', mt: 4 }}>Vendor not found.</Box>;
	}

	return (
		<>
			<Box sx={{ height: 'calc(100vh - 70x)', overflowY: 'auto' }}>
				{/* Vendor Details */}
				<Box sx={{ py: 2 }}>
					<FixedBackButton />
				</Box>
				<Box sx={{ pt: 2 }}>
					<BasicDetailsCard vendor={vendorData} />
					<Box sx={{ pt: 3 }}>
						<BussinessDetailsCard vendor={vendorData} />
					</Box>
				</Box>

				{/* Permissions Table */}
				<Box sx={{ mt: 2 }}>
					<MenuTable
						vendorDisabel={vendorDisabel}
						permissions={vendorData.permissions}
						onChange={handlePermissionChange} // call when permissions change
					/>
				</Box>

				{/* Action Buttons */}
				{/* <Box
					sx={{
						position: 'fixed', // fix at viewport bottom
						bottom: 0,
						left: 65,
						right: 0,
						bgcolor: 'background.paper', // ensure background covers content underneath
						boxShadow: '0 -2px 8px rgba(0,0,0,0.1)', // subtle shadow on top
						p: 1,
						zIndex: 1300, // above most content (MUI modal default zIndex is 1300)
					}}
				>
					<Stack direction="row" spacing={2} justifyContent="end">
						<Button
							variant="contained"
							color="success"
							onClick={() => handleOpenModal('accepted')}
							// disabled={updating}
						>
							Submit
						</Button>
						<Button
							variant="contained"
							color="error"
							onClick={() => handleOpenModal('rejected')}
							disabled={updating}
						>
							Reject
						</Button>
					</Stack>
				</Box>  */}

				{/* Confirmation Modal */}
				{/* <Dialog open={modalOpen} onClose={() => setModalOpen(false)}>
					<DialogTitle>
						Confirm {actionType === 'accepted' ? 'Approval' : 'Rejection'}
					</DialogTitle>
					<DialogContent>
						<Typography>
							Are you sure you want to {actionType} this vendor request?
						</Typography>
					</DialogContent>
					<DialogActions>
						<Button onClick={() => setModalOpen(false)} disabled={updating}>
							Cancel
						</Button>
						<Button
							variant="contained"
							color={actionType === 'accepted' ? 'success' : 'error'}
							onClick={handleConfirm}
							disabled={updating}
						>
							{updating ? 'Processing...' : 'Confirm'}
						</Button>
					</DialogActions>
				</Dialog> */}
			</Box>
		</>
	);
}
